import { useDeleteInvoiceBo } from "@/api/invoice";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";
import { Loader2, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

type ModalProps = {
  closeModal: () => void;
  id: string | null;
};

export const InvoiceDeletionModal = ({ closeModal, id }: ModalProps) => {
  const { t } = useTranslation(["boInvoices", "common"]);
  const { mutateAsync: deleteInvoice, isPending } = useDeleteInvoiceBo();

  const handleDeleteInvoice = async () => {
    if (!id) return;
    await deleteInvoice(id);
    closeModal();
  };

  return (
    <Modal
      open={!!id}
      onClose={closeModal}
      dismissible
      size="sm"
      title={
        <div className="flex items-center gap-3">
          <div className="flex size-10 items-center justify-center rounded-full bg-red-100">
            <Trash2 className="size-5 text-red-600" />
          </div>
          <span>{t("deleteModal.title")}</span>
        </div>
      }
      description={t("deleteModal.description")}
      footer={
        <div className="flex w-full flex-col gap-2 md:flex-row">
          <Button
            variant="destructive"
            onClick={handleDeleteInvoice}
            disabled={isPending}
            className="flex-1"
          >
            {isPending ? <Loader2 className="animate-spin" /> : t("deleteModal.submit")}
          </Button>
          <Button variant="outline" onClick={closeModal} disabled={isPending} className="flex-1">
            {t("common:actions.cancel")}
          </Button>
        </div>
      }
    />
  );
};
